<template>
   <dashboard-layout>
        <div> 
        <div class="sh-mainpanel"> 
            <div class="sh-pagetitle">
                <div class="input-group">
                <!-- <input type="search" class="form-control" placeholder="Search"> -->
                <span class="input-group-btn">
                    <!-- <button class="btn"><i class="fa fa-search"></i></button> -->
                </span><!-- input-group-btn -->
                </div><!-- input-group -->
                <div class="sh-pagetitle-left">
                <!-- <div class="sh-pagetitle-icon"><i class="icon ion-ios-home"></i></div> -->
                <div class="sh-pagetitle-title"> 
                    <h2>Home</h2>
                </div><!-- sh-pagetitle-left-title -->
                </div><!-- sh-pagetitle-left -->
            </div><!-- sh-pagetitle -->

            <div class="sh-pagebody">
                <div class="row row-sm">
                    <div class="col-lg-12">
                        <div class="row row-xs">
                            <div class="col-6 col-sm-4 col-md">
                                <a href="/create-order" class="shortcut-icon">
                                <div>
                                    <i class="icon ion-plus"></i>
                                    <span>Nieuwe Order</span>
                                </div>
                                </a>
                            </div><!-- col -->
                            <div class="col-6 col-sm-4 col-md">
                                <a href="/orders" class="shortcut-icon">
                                <div>
                                    <i class="icon ion-ios-search"></i>
                                    <span>Orders</span>
                                </div>
                                </a>
                            </div><!-- col -->
                            <div class="col-6 col-sm-4 col-md mg-t-10 mg-sm-t-0">
                                <a href="/debtors" class="shortcut-icon">
                                <div>
                                    <i class="icon ion-person-stalker"></i>
                                    <span>Klanten</span>
                                </div>
                                </a>
                            </div><!-- col -->
                            <div class="col-6 col-sm-4 col-md mg-t-10 mg-md-t-0">
                                <a href="https://zine.all4trade.nl/admin" class="shortcut-icon" target="_blank">
                                <div>
                                    <i class="icon ion-share"></i>
                                    <span>Zine</span>
                                </div>
                                </a>
                            </div><!-- col --> 
                        </div><!-- row -->
                    </div><!-- col-8 --> 
                </div><!-- row -->
            </div><!-- sh-pagebody -->
            <!-- <div class="sh-footer">
                <div>Copyright &copy; 2017. All Rights Reserved. Shamcey Dashboard Admin Template</div>
                <div class="mg-t-10 mg-md-t-0">Designed by: <a href="http://themepixels.me">ThemePixels</a></div>
            </div> -->
        </div><!-- sh-mainpanel --> 
    </div>
   </dashboard-layout>
</template>

<script>
import dashboardLayout from '../layouts/dashboard_layout'
import { mapState } from 'vuex'
export default {
    name:'dashboard',
    components:{
        dashboardLayout
    },
    computed:{
        ...mapState({
            loading:(state)=>state.loading,
            endpoint:(state)=>state.endpoint,
        })
    },
    data() {
        return {

        }
    },
    created(){
        this.$store.dispatch('get',this.endpoint+'user')
        .then((data)=>{
            console.log('organization',data.data);
            this.item = data.data;
        })
        .catch((error)=>{
            console.log(error.request);
        });
    }
}
</script>